'use client';
import { useSetAtom } from "jotai";
import { useEffect } from 'react';
import { translationState } from '@/components/Atoms/TranslationAtom';
import {dictionaryType} from "@/lib/definitions/definitions";
import {Locale} from "@/i18n/i18n-config";
import {lngState} from "@/components/Atoms/LngAtom";

export function SetTranslationData({ dictionary, lng }: {dictionary: dictionaryType, lng: Locale }) {

    const setTranslation = useSetAtom(translationState);
    const setLng = useSetAtom(lngState);

    useEffect(() => {
        setTranslation({dictionary, lng});
        setLng({lng})
    }, [dictionary, lng]);

    return null;
}
